import { render, staticRenderFns } from "./JsonObject.vue?vue&type=template&id=0a0cec40&scoped=true&"
import script from "./JsonObject.vue?vue&type=script&lang=js&"
export * from "./JsonObject.vue?vue&type=script&lang=js&"
import style0 from "./JsonObject.vue?vue&type=style&index=0&id=0a0cec40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cec40",
  null
  
)

export default component.exports